<template>
  <user-create-form @submit="saveUser"/>
</template>
<script>
  import UserCreateForm from './UserCreate/UserCreateForm';
  import ClientService from 'src/services/ClientService';
  import { getRouteName, routeTypes } from "src/config/routeTypes";
  import entities from "src/config/entities";

  export default {
    name: 'user-create',
    components: {
      UserCreateForm
    },
    data() {
      return {

      }
    },
    methods: {
      async saveUser(user) {
        let clientId = user.client.uuid;
        let data = {
          email: user.email,
          given_name: user.given_name,
          role: 'client-owner',
          job_board_id: user.site.id
        };
        let result = await ClientService.inviteUser(clientId, data);
        if(result && this.$route.query.client_uuid) {
          this.$router.push({ path: `/contacts/clients/${this.$route.query.client_uuid}/users`})
        }
      }
    }
  }
</script>
<style>
</style>
